import {React, useState, useEffect} from "react";
import {
  Container,
  Form,
  Row, 
  Col,
  Button,
  ButtonGroup 
} from 'reactstrap';
import './layout.css';
import { isGuid } from '../../App.js';
import AudioCapturePopup from "../helpers/AudioCapturePopup.js";

function InformationPageContent(props){
  const{
    slideTitle,
    information,
    contentImage,
    editing,
    handleTitleChange,
    handleTextChange,
    openMediaCapture,
    getMediaById
  } = props;
  console.log("rendering InformationPageContent, with props: ", props);

  const [resolvedImageSrc, setResolvedImageSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function resolveImage() {
      if (!contentImage) {
        setResolvedImageSrc(null);
        return;
      }

      // if it’s a GUID (or looks like one), fetch via getMediaById
      if (isGuid(contentImage)) {
        try {
          const media = await getMediaById(contentImage);
          if (!cancelled) {
            // assume media is a blob or something you can convert
            // e.g. URL.createObjectURL(media) or a base64 string
            const url = URL.createObjectURL(media.file);
            setResolvedImageSrc(url);
          }
        } catch (err) {
          console.error("Failed to load media:", err);
          if (!cancelled) {
            setResolvedImageSrc(null);
          }
        }
      } else {
        // it's a URL already
        setResolvedImageSrc(contentImage);
      }
    }

    resolveImage();

    return () => {
      cancelled = true;
      // Optionally, release object URL if used
      if (resolvedImageSrc && resolvedImageSrc.startsWith("blob:")) {
        URL.revokeObjectURL(resolvedImageSrc);
      }
    };
  }, [contentImage, getMediaById]);

  return(
    // <>
      <Container className='instruct-information-container border' style={{height:'100%'}} fluid={true}>
        {(slideTitle || editing) && (
        <Row className="border row-col-borders">
          {editing ? 
            (<input className="instruct-information-title" type="text" value={slideTitle} onChange={handleTitleChange}/>) 
            : 
            (<legend className='instruct-information-title'>{slideTitle}</legend>)
          }
        </Row>
        )}
        {(editing || information || contentImage) && (
          <Row className="row-col-borders" style={slideTitle ? { height: '80%' } : {height:'100%'}}>
            {(editing || information) && (
              <Col xs={(contentImage || editing) ? 8 : 12} style={{height:'100%'}} className="row-col-borders">
                {editing ? (
                  <textarea
                    className="instruct-information-text"
                    value={information}
                    onChange={handleTextChange}
                    rows={8} // adjust number of lines
                    style={{ width: "100%", height: "100%", resize: "none", margin: 0, boxSizing: "border-box" }}
                  />
                ) : (
                  <legend className='instruct-information-text'>{information}</legend>)
                }
              </Col>
            )}
            {(editing || contentImage) && (
              <Col xs={(information || editing) ? 4 : 12} style={{height:'100%', position: "relative", display: "inline-block"}} className="row-col-borders d-flex justify-content-center align-items-center ">
                {resolvedImageSrc ? (
                  <img
                    className="information-content-image"
                    src={resolvedImageSrc}
                    alt={slideTitle ?? ''}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      width: 'auto',
                      height: 'auto',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                  />
                ) : null}
                {editing && (
                  <Button style={{position: 'absolute', top: "50%", left: "50%", transform: "translate(-50%, 50%)",  width: "80%",  opacity: 0.85,}} onClick={openMediaCapture}>Image to show beside text</Button>
                )}
              </Col>
            )}
          </Row>
        )}
      </Container>
    // </>
  )
}

function InformationPageControls(props){
  const{
    NextStepText,
    handleNextClick,
    currentTraining,
    currentStep,
    updateState,
    audioButtonText
  } = props;
  console.log("InformationPageControls with: ", props);
  return (
    <>
    <Form className='instruct-control-container'>
      <ButtonGroup className='instruct-control-bar' size='lg'>
          {/* <Button className='instruct-control-button' onClick={() => handleSetStartClick()}>{VideoStartText}</Button>
          <Button className='instruct-control-button' onClick={() => handleSetEndClick()}>{VideoEndText}</Button> */}
          <AudioCapturePopup 
            ref={window.audioRef} 
            buttonClass={'instruct-control-button'}
            currentTraining={currentTraining} 
            currentStep={currentStep} 
            updateState={updateState} 
            buttonText={audioButtonText}
          />
          <Button className='instruct-control-button' color="primary" onClick={() => handleNextClick()}>{NextStepText}</Button>
      </ButtonGroup>
    </Form>
    </>
  );
}

export {InformationPageContent, InformationPageControls};